import React, { Component } from "react";
import {
  Card,
  Row,
  Col,
  Input,
  Select,
  Tooltip,
  DatePicker,
  notification,
  Checkbox,
  message
} from "antd";
import { Fragment } from "react";
import moment from "moment";
import PrimaryButton from "../CommonComponent/Buttons/PrimayButton";
import { Form } from "@ant-design/compatible";
import Config from "../../config";
import axios from "axios";
import ActivityLog from "./ActivityLog";
import Attachment from "./Attachment";
//import Contacts from "./Contacts";
//import Notes from "./Notes";
import { data, valHooks } from "jquery";
import { async } from "rxjs";

const { Option } = Select;
const { TextArea } = Input;

export default class TicketDetailTab extends Component {
  state = {
    data: null,
    activetab: 0,
    notesHistoryArray: [],
    activeKey: this.props.activeKey,
    privateNote: true,
    publicNote: false,
    editButtonClicked: false,
    enableCategorySection: false,
    enableNoteSection: false,
    // to get list of data
    categories: [],
    priorities: [],
    ticketStatuses: [],
    assignedTo: [],
    // to get selected data
    selectedCategoryID: null,
    selectedPriorityID: null,
    selectedStatusID: null,
    selectedAssignedTo: null,
    selectedStatus: null,
    selectedAssignedToEmail: null,
    note: null,
    isSaveButtonEnabled: false,
    IsPrivate:
      sessionStorage.getItem("rolename").includes("Group User") ||
      sessionStorage.getItem("rolename").includes("Provider") ||
      sessionStorage.getItem("rolename").includes("IPA User")
        ? false
        : true,
  };
  componentDidMount() {
    this.fetchTicketDetails();
    this.fetchNotesHistory();
    this.getTicketMasterData();
    const roleName = sessionStorage.getItem("rolename");

    if (roleName && roleName.includes("Plan Admin")) {
      this.getAlluser();
    }
  }

  fetchTicketDetails = () => {
    const ticketID = 10;
    const token = "generated_token"; // Replace 'generated_token' with the actual generated token

    axios
      .get(
        `${Config.Ticket}/GetTicketDetailsByTicketID?TicketID=${this.props.TicketInfo.TicketID}`,
        {
          headers: {
            Authorization: sessionStorage.getItem("access_token"),
          },
        }
      )
      .then((response) => {
        // Handle the response data here
        this.setState({
          data: response.data,
          selectedCategoryID: response.data.CategoryID,
          selectedPriorityID: response.data.PriorityID,
          selectedStatusID: response.data.TicketStatusID,
          selectedAssignedTo: response.data.AssignedToUsername,
          selectedStatus: response.data.TicketStatus,
        });
        console.log("rrr", response.data);
      })
      .catch((error) => {
        // Handle errors here
        console.error(error);
      });
  };
  fetchNotesHistory = () => {
    const requestData = {
      TicketID: this.props.TicketInfo.TicketID,
      Roles: sessionStorage.getItem("rolename").split(","),
    };
    fetch(`${Config.Ticket}/GetNotesByTicketID`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: sessionStorage.getItem("access_token"),
      },
      body: JSON.stringify(requestData),
    })
      .then((response) => response.json())
      .then((data) => {
        // Handle the response data here
        console.log(data);
        this.setState({
          notesHistoryArray: data,
        });
        // console.log("notesHistoryArray", this.state.notesHistoryArray);
      })
      .catch((error) => {
        // Handle errors here
        console.error(error);
      });
  };
  getTicketDetails = (value) => {
    this.setState({
      activetab: value,
    });
  };

  editButton = () => {
    this.setState({
      editButtonClicked: true,
      enableCategorySection: sessionStorage
        .getItem("rolename")
        .includes("Plan Admin")
        ? true
        : false,
      enableNoteSection:
        sessionStorage.getItem("rolename").includes("Group User") ||
        sessionStorage.getItem("rolename").includes("Provider") ||
        sessionStorage.getItem("rolename").includes("IPA User")
          ? true
          : false,
    });
  };
  privateNoteClicked = () => {
    this.setState({
      privateNote: true,
      publicNote: false,
      IsPrivate: true,
    });
  };
  publicNoteClicked = () => {
    this.setState({
      privateNote: false,
      publicNote: true,
      IsPrivate: false,
    });
  };

  closeTicketDetail = () => {
    //console.log("Shiv")
    this.props.remove(this.state.activeKey);
  };

  getTicketMasterData = async () => {
    let axiosConfig = {
      headers: {
        Authorization: sessionStorage.getItem("access_token"),
        Accept: "application/json",
        "Content-type": "application/json",
      },
      body: JSON.stringify({}),
    };

    await axios
      .get(
        Config.Ticket +
          "/getmasterdata?TenantID=" +
          sessionStorage.getItem("Tanent"),
        axiosConfig
      )
      .then((res) => {
        // setGetTicketData(res.data);
        // setTicketData({
        //   ...ticketData,
        //   OriginQueueID: res.data.QueueMaster.find(
        //     (e) => e.Queue === props.Fromwhere
        //   ).QueueID,
        // });
        this.setState({
          categories: res.data.Categoty,
          priorities: res.data.Priority,
          ticketStatuses: res.data.TicketStatus,
        });
        console.log("resp wegot", res.data.Categoty);
        console.log("arr respo", this.state.categories);
      })
      .catch((err) => {});
  };
  filterByUsername(username, userList) 
   { 
    const filteredUsers = userList.filter(user => user.UserName === username);
    return filteredUsers; 
    }
  
  getAlluser = async () => {
    fetch(
      `${Config.Ticket}/GetAllUserNameByRole?TenantID=${sessionStorage.getItem(
        "Tanent"
      )}&Role=${"Plan Admin"}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: sessionStorage.getItem("access_token"), // Assuming token is passed as a bearer token
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        console.log("data##",data.UserList)
        const usernameToFind = this.state.selectedAssignedTo; 
        if(usernameToFind !== null){
          const filteredUsers = this.filterByUsername(usernameToFind, data.UserList);
          this.setState({
            selectedAssignedToEmail: filteredUsers[0].Email,
          })
        }
        // Handle the response data here
        this.setState({
          assignedTo: data.UserList,
        });
      })
      .catch((error) => {
        // Handle any errors that occurred during the API call
        console.error(error);
      });
  };
  handleUpdate = () => {
    const url = `${Config.Ticket}/EditTicket`;

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: sessionStorage.getItem("access_token"),
      },
      body: JSON.stringify({
        TicketID: this.props.TicketInfo.TicketID,
        TicketCategoryID: this.state.selectedCategoryID,
        TicketPriorityID: this.state.selectedPriorityID,
        TicketStatusID: this.state.selectedStatusID,
        ModifiedBy: sessionStorage.getItem("userEmail"),
        ModifiedByUsername: sessionStorage.getItem("userName"),
        Note: this.state.note,
        IsPrivate: this.state.IsPrivate,
        AssignedTo: this.state.selectedAssignedTo,
        Roles: sessionStorage.getItem("rolename").split(","),
        TicketStatus: this.state.selectedStatus,
        Planname: sessionStorage.getItem("planName"),
        AssignedToEmailID: this.state.selectedAssignedToEmail,
        // TicketID: "18",
        // TicketTypeID: 4,
        // TicketCategoryID: 2,
        // TicketPriorityID: null,
        // TicketStatusID: 1,
        // ModifiedBy: "ghvignesh@mirrahealthcare.com",
        // ModifiedByUsername: "Goutham V",
        // Note: "Note created using api",
        // IsPrivate: true,
        // AssignedTo: null,

        // TicketID: "5258",
        // TicketCategoryID: 1,
        // TicketPriorityID: 1,
        // TicketStatusID: 1,
        // ModifiedBy: "ghvignesh@mirrahealthcare.com",
        // ModifiedByUsername: "Goutham V",
        // Note: "Note created using api",
        // IsPrivate: true,
        // AssignedTo: n,
      }),
    };

    fetch(url, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        // Handle the response data here
        console.log(data);
        this.fetchNotesHistory();
        this.setState({
          editButtonClicked: false,
          enableCategorySection: false,
          note: null,
        });
        this.fetchTicketDetails();
        window.dispatchEvent(new Event("apiCallSuccess"));
        message.success("Ticket edited successfully");
      })
      .catch((error) => {
        // Handle the error here
        console.error("Error:", error);
      });
  };
  handleCategoryChange = (value) => {
    if (value === "remove") {
      // If the "Remove" option is selected
      this.setState({ selectedCategoryID: null, isSaveButtonEnabled: true });
    } else {
      // If a regular option is selected
      this.setState({ selectedCategoryID: value, isSaveButtonEnabled: true });
    }
  };
  handlePriorityChange = (value) => {
    if (value === "remove") {
      // If the "Remove" option is selected
      this.setState({ selectedPriorityID: null, isSaveButtonEnabled: true });
    } else {
      // If a regular option is selected
      this.setState({ selectedPriorityID: value, isSaveButtonEnabled: true });
    }
  };
  handleStatusChange = (value) => {
    const jsonString = value;

try {
  const obj = JSON.parse(jsonString);
  const TicketStatusID = obj.TicketStatusID;
  const TicketStatus = obj.TicketStatus;
  this.setState({ selectedStatusID: TicketStatusID, selectedStatus: TicketStatus, isSaveButtonEnabled: true });
} catch (error) {
  console.error('Error parsing JSON:', error);
}
    // console.log("valll",value.TicketStatusID)
    // this.setState({ selectedStatusID: value.TicketStatusID, selectedStatus: value.TicketStatus, isSaveButtonEnabled: true });
  };
  handleAssignedToChange = (value) => {
    const jsonString =value;

try {
  const obj = JSON.parse(jsonString);
  const userName = obj.UserName;
  const userEmail = obj.Email;

   // const userName = value.UserName
    if (value === "remove") {
      // If the "Remove" option is selected
      this.setState({ selectedAssignedTo: null, isSaveButtonEnabled: true });
    } else {
      // If a regular option is selected
      this.setState({ selectedAssignedTo: userName,selectedAssignedToEmail:userEmail, isSaveButtonEnabled: true });
    }

} catch (error) {
  console.error('Error parsing JSON:', error);
}
  };

  handleNoteChange = (event) => {
    const note = event.target.value;
    this.setState({ note, isSaveButtonEnabled: true });
  };
  render() {
    console.log("user", sessionStorage.getItem("rolename"));
    console.log("selectedCategoryID", this.state.selectedCategoryID);
    console.log("selectedPriorityID", this.state.selectedPriorityID);
    console.log("selectedStatusID", this.state.selectedStatusID);
    console.log("selectedAssignedTo", this.state.selectedAssignedTo);
    console.log("IsPrivate", this.state.IsPrivate);
    console.log("note", this.state.note);
    console.log("TicketTypeID", this.props.TicketInfo);
    const ticketInformation = this.props.TicketInfo;
    const dateFormat = "MMM DD, YYYY";
    const userRole = sessionStorage.getItem("rolename");
    const shouldRenderCheckbox =
      userRole.includes("Group User") ||
      userRole.includes("IPA User") ||
      userRole.includes("Provider");

    console.log("TD", ticketInformation);
    return (
      <div>
      <div style={{ display: "none"}}>
      {/* JSX content for TicketTab.js */}
      {/* <TicketSidebar data={this.state.ticketStatuses} ref={(ref) => (this.ticketSidebarRef = ref)} /> */}
    </div>
      <Fragment>
        <Row className="m-2">
          <Col className="m-2 pt-0 details-header-sub">
            Ticket ID: {ticketInformation.TicketID}
          </Col>
          {this.state.activetab === 0 && !this.state.editButtonClicked && (
            <Col span={21} style={{ textAlign: "right" }}>
              <button className="incidentEdit" onClick={this.editButton}>
                Edit
              </button>
            </Col>
          )}
        </Row>
        <div className="pt-1 pb-1">
          <Card className="button-area pr-2">
            <Row justify="space-between">
              <Col span={6}>
                <PrimaryButton
                  className={
                    this.state.activetab == 0
                      ? "details-tab py-1 px-5"
                      : "simple-button px-5 profileTabs"
                  }
                  onClick={() => this.getTicketDetails(0)}
                  label={"01. Basic information"}
                />
              </Col>
              {/* Clicla */}
              <Col span={4}>
                <PrimaryButton
                  className={
                    this.state.activetab == 1
                      ? "details-tab py-1 px-5"
                      : "simple-button px-5 profileTabs"
                  }
                  onClick={() => this.getTicketDetails(1)}
                  label={"02. Attachments"}
                />
              </Col>

              <Col span={4}>
                <PrimaryButton
                  className={
                    this.state.activetab == 4
                      ? "details-tab py-1 px-5"
                      : "simple-button px-5 profileTabs"
                  }
                  onClick={() => this.getTicketDetails(4)}
                  label={"03. Activity Log"}
                />
              </Col>
            </Row>
          </Card>
        </div>
        {this.state.activetab === 0 ? (
          <Form>
            <div className="fieldBackground">
              <div className="addIncident">01. Basic Information</div>
              <div className="formDesignRow">
                <div style={{ width: "18%" }}>
                  <span className="addStaff-text">Caller Name </span>
                  <Form.Item>
                    <Input
                      size="small"
                      name="callerFirstName"
                      placeholder="Enter"
                      value={this.state.data?.POCName}
                      disabled={true}
                    />
                  </Form.Item>
                </div>

                <div style={{ width: "18%" }}>
                  <span className="addStaff-text">Contact No. </span>
                  <Form.Item>
                    <Input
                      size="small"
                      name="callerContactNumber"
                      placeholder="Enter"
                      value={this.state.data?.POCContactNumber}
                      disabled={true}
                    />
                  </Form.Item>
                </div>

                <div style={{ width: "18%" }}>
                  <span className="addStaff-text">Email Address </span>
                  <Form.Item>
                    <Input
                      size="small"
                      name="callerTitle"
                      placeholder="Enter"
                      value={this.state.data?.POCEmail}
                      disabled={true}
                    />
                  </Form.Item>
                </div>

                <div style={{ width: "18%" }}>
                  <span className="addStaff-text">Ticket date </span>
                  <Form.Item>
                    <DatePicker
                      size="small"
                      disabled={true}
                      defaultValue={moment(this.state.data?.CreatedDate)}
                      format={dateFormat}
                    />
                  </Form.Item>
                </div>
              </div>
            </div>
            <div className="fieldBackground">
              <div className="addIncident">02. Ticket Details</div>
              <div className="textArea textField">
                <div className="incidentFlex">
                  <span className="addStaff-text1">
                    Description
                    <span style={{ color: "red" }}>*</span>
                  </span>
                </div>
                <Form.Item>
                  <TextArea
                    className="addStaff"
                    placeholder="Type here"
                    autoSize={{ minRows: 3 }}
                    //    onChange={handleDescriptionChange}
                    maxLength={5001}
                    value={this.state.data?.Description}
                    disabled={true}
                  />
                </Form.Item>
              </div>
              <div className="formDesignRow">
                <div style={{ width: "18%" }}>
                  <span className="addStaff-text">
                    Ticket Type
                    <span style={{ color: "red" }}>*</span>
                  </span>
                  <Form.Item>
                    <Select
                      size="small"
                      placeholder={
                        this.state.data ? this.state.data.TicketType : "Select"
                      }
                      defaultValue={this.state.data?.TicketType}
                      disabled={true}
                      //   onChange={handleTicketTypeChange}
                    ></Select>
                    {/* )} */}
                  </Form.Item>
                </div>
                <div
                  style={{
                    width: "18%",
                    display:
                      this.state.data?.AssignedTaxID === null &&
                      this.state.data?.AssignedNPI === null
                        ? "none"
                        : "block",
                  }}
                >
                  <span className="addStaff-text">
                    TIN
                    <span style={{ color: "red" }}>*</span>
                  </span>
                  <Form.Item>
                    <Select
                      size="small"
                      placeholder={
                        this.state.data ? this.state.data.AssignedTaxID : ""
                      }
                      defaultValue={this.state.data?.AssignedTaxID}
                      disabled={true}
                      //   onChange={handleTicketTypeChange}
                    ></Select>
                    {/* )} */}
                  </Form.Item>
                </div>
                <div
                  style={{
                    width: "18%",
                    display:
                      this.state.data?.AssignedTaxID === null &&
                      this.state.data?.AssignedNPI === null
                        ? "none"
                        : "block",
                  }}
                >
                  <span className="addStaff-text">
                    NPI
                    <span style={{ color: "red" }}>*</span>
                  </span>
                  <Form.Item>
                    <Select
                      size="small"
                      placeholder={
                        this.state.data ? this.state.data.AssignedNPI : ""
                      }
                      defaultValue={this.state.data?.AssignedNPI}
                      disabled={true}
                      //   onChange={handleTicketTypeChange}
                    ></Select>
                    {/* )} */}
                  </Form.Item>
                </div>
              </div>
            </div>
            {sessionStorage.getItem("rolename").includes("Plan Admin") && (
              <div className="fieldBackground">
                <div className="addIncident">03. Categorization</div>
                <div className="formDesignRow">
                  <div style={{ width: "18%" }}>
                    <span className="addStaff-text">
                      Category Type
                      {/* <span style={{ color: "red" }}>*</span> */}
                    </span>
                    <Form.Item>
                      <Select
                        size="small"
                        placeholder={
                          this.state.data
                            ? this.state.data.Category !== null
                              ? this.state.data.Category
                              : "Select"
                            : "Select"
                        }
                        defaultValue={this.state.data?.Category}
                        disabled={
                          !this.state.editButtonClicked &&
                          !this.state.enableCategorySection
                        }
                        onChange={this.handleCategoryChange}
                        className={!this.state.editButtonClicked &&
                          !this.state.enableCategorySection ? "" : "custom-select1"}
                      >
                        <Select.Option key="remove" value="remove">
                          Select
                        </Select.Option>
                        {this.state.categories.map((category) => (
                          <Select.Option
                            key={category.CategoryID}
                            value={category.CategoryID}
                          >
                            {category.Category}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </div>
                  <div style={{ width: "18%" }}>
                    <span className="addStaff-text">
                      priority
                      {/* <span style={{ color: "red" }}>*</span> */}
                    </span>
                    <Form.Item>
                      <Select
                        size="small"
                        placeholder={
                          this.state.data
                            ? this.state.data.Priority !== null
                              ? this.state.data.Priority
                              : "Select"
                            : "Select"
                        }
                        defaultValue={this.state.data?.Priority}
                        disabled={
                          !this.state.editButtonClicked &&
                          !this.state.enableCategorySection
                        }
                        onChange={this.handlePriorityChange}
                        className={!this.state.editButtonClicked &&
                          !this.state.enableCategorySection ? "" : "custom-select1"}
                      >
                        <Select.Option key="remove" value="remove">
                          Select
                        </Select.Option>
                        {this.state.priorities.map((priority) => (
                          <Select.Option
                            key={priority.PriorityID}
                            value={priority.PriorityID}
                          >
                            {priority.Priority}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </div>
                  <div style={{ width: "18%" }}>
                    <span className="addStaff-text">
                      status
                      {/* <span style={{ color: "red" }}>*</span> */}
                    </span>
                    <Form.Item>
                      <Select
                        size="small"
                        placeholder={
                          this.state.data
                            ? this.state.data.TicketStatus !== null
                              ? this.state.data.TicketStatus
                              : "Select"
                            : "Select"
                        }
                        defaultValue={this.state.data?.TicketStatus}
                        disabled={
                          !this.state.editButtonClicked &&
                          !this.state.enableCategorySection
                        }
                        onChange={this.handleStatusChange}
                        className={!this.state.editButtonClicked &&
                          !this.state.enableCategorySection ? "" : "custom-select1"}
                      >
                        {this.state.ticketStatuses.map((ticketStatus) => (
                          <Select.Option
                            key={ticketStatus.TicketStatusID}
                            value={JSON.stringify(ticketStatus)}
                          >
                            {ticketStatus.TicketStatus}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </div>
                  <div style={{ width: "18%" }}>
                    <span className="addStaff-text">
                      Assigned to
                      {/* <span style={{ color: "red" }}>*</span> */}
                    </span>
                    <Form.Item>
                      <Select
                        size="small"
                        placeholder={
                          this.state.data
                            ? this.state.data.AssignedToUsername !== null
                              ? this.state.data.AssignedToUsername
                              : "Select"
                            : "Select"
                        }
                        defaultValue={this.state.data?.AssignedToUsername}
                        disabled={
                          !this.state.editButtonClicked &&
                          !this.state.enableCategorySection
                        }
                        onChange={this.handleAssignedToChange}
                        className={!this.state.editButtonClicked &&
                          !this.state.enableCategorySection ? "" : "custom-select1"}
                        showSearch // Add showSearch prop to make it searchable
                        optionFilterProp="children" // Specify the property to use for filtering
                        //   onChange={handleTicketTypeChange}
                      >
                        <Select.Option key="remove" value="remove">
                          Select
                        </Select.Option>
                        {this.state.assignedTo.map((assignedTo) => (
                          <Select.Option
                            key={assignedTo.UserName}
                            value={JSON.stringify(assignedTo)}
                          >
                            {assignedTo.UserName}
                          </Select.Option>
                        ))}
                      </Select>
                      {/* )} */}
                    </Form.Item>
                  </div>
                </div>
              </div>
            )}
            <div className="fieldBackground">
              <Row style={{ paddingTop: "10px" }}>
                <Col className="addIncident" style={{ paddingRight: "820px" }}>
                  {sessionStorage.getItem("rolename").includes("Plan Admin")
                    ? "04. Notes"
                    : "03. Notes"}
                </Col>
                <Col style={{ textAlign: "right" }}>
                  {!shouldRenderCheckbox && (
                    <Checkbox
                      checked={this.state.privateNote}
                      // style={{ borderRadius: "5%" }}
                      onClick={this.privateNoteClicked}
                      disabled={
                        !this.state.editButtonClicked &&
                        !this.state.enableCategorySection &&
                        !this.state.enableNoteSection
                      }
                    >
                      Private Note
                    </Checkbox>
                  )}
                </Col>
                <Col>
                  {!shouldRenderCheckbox && (
                    <Checkbox
                      // style={{ borderRadius: "50%" }}
                      checked={this.state.publicNote}
                      onClick={this.publicNoteClicked}
                      disabled={
                        !this.state.editButtonClicked &&
                        !this.state.enableCategorySection &&
                        !this.state.enableNoteSection
                      }
                    >
                      Public Note
                    </Checkbox>
                  )}
                </Col>
              </Row>
              <div className="textArea textField">
                <div className="incidentFlex">
                  <span className="addStaff-text1">
                    Notes
                    {/* <span style={{ color: "red" }}>*</span> */}
                  </span>
                </div>
                <Form.Item>
                  <TextArea
                    id={!this.state.editButtonClicked ? "disablenote" : null}
                    className={
                      !this.state.editButtonClicked
                        ? "addstaffDisabled"
                        : "addStaff"
                    }
                    placeholder="Type here"
                    autoSize={{ minRows: 3 }}
                    onChange={this.handleNoteChange}
                    value={this.state.note}
                    maxLength={5001}
                    //  value={this.state.data?.Description}
                    disabled={!this.state.editButtonClicked}
                  />
                </Form.Item>
              </div>
            </div>
            <div className="fieldBackground">
              <div className="addIncident">
                {" "}
                {sessionStorage.getItem("rolename").includes("Plan Admin")
                  ? "05. Resolution Notes History"
                  : "04. Resolution Notes History"}
              </div>
              <div>
                <div className="">
                  <div>
                    {/* {this.state.notesHistoryArray.length === 0 && (
                      <div
                        className="fieldBackground"
                        style={{ textAlign: "center" }}
                      >
                        No datas
                      </div>
                    )} */}
                    {/* {this.state.notesHistoryArray.length != 0 && ( */}
                    <div>
                      <div className="fieldBackground">
                        <div
                          className="attachmentTableDiv tableMarginLeftPadding"
                          style={{ marginTop: "0px" }}
                        >
                          <table
                            className="attachmentTable incidentdummyTable1"
                            style={{ width: "100%" }}
                          >
                            <thead>
                              <tr>
                                <th>#</th>
                                <th>Added On</th>
                                <th>Added By</th>
                                <th>Description</th>

                                <th></th>
                              </tr>
                            </thead>
                            <tbody className="tableBody">
                              {this.state.notesHistoryArray.length != 0 &&
                                this.state.notesHistoryArray.map(
                                  (item, index) => {
                                    if (index <= 8) {
                                      var serialNumber = "0" + (index + 1);
                                    } else {
                                      var serialNumber = index + 1;
                                    }

                                    const formatDate = (dateTimeString) => {
                                      const options = {
                                        year: "numeric",
                                        month: "short",
                                        day: "numeric",
                                        hour: "numeric",
                                        minute: "numeric",
                                        hour12: false,
                                      };

                                      const date = new Date(dateTimeString);
                                      return new Intl.DateTimeFormat(
                                        "en-US",
                                        options
                                      ).format(date);
                                    };
                                    return (
                                      <tr>
                                        <td>{serialNumber}</td>
                                        <Tooltip
                                          title={formatDate(item.CreatedDate)}
                                        >
                                          <td>
                                            {formatDate(item.CreatedDate)}
                                          </td>
                                        </Tooltip>
                                        <Tooltip title={item.CreatedByUsername}>
                                          <td>{item.CreatedByUsername}</td>
                                        </Tooltip>
                                        <Tooltip title={item.Description}>
                                          <td>{item.Description}</td>
                                        </Tooltip>
                                        {/* <td>
                                    <img
                                      src={DeleteImg}
                                      onClick={() =>
                                        this.showModal(item, "attachments")
                                      }
                                      style={{
                                        width: "11px",
                                        height: "15px",
                                        cursor: "pointer",
                                      }}
                                      alt="delete"
                                    />
                                  </td> */}
                                      </tr>
                                    );
                                  }
                                )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    {this.state.notesHistoryArray.length === 0 && (
                      <div
                        className="fieldBackground"
                        style={{ textAlign: "center" }}
                      >
                        No data
                      </div>
                    )}
                    {/* )} */}
                  </div>
                  {this.state.editButtonClicked == false && (
                    <Row className="m-2">
                      <Col span={24} style={{ textAlign: "right" }}>
                        <button
                          className="incidentCancelButton"
                          onClick={this.closeTicketDetail}
                        >
                          Close
                        </button>
                      </Col>
                    </Row>
                  )}
                  {this.state.editButtonClicked == true && (
                    <Form.Item>
                      <div className="incidentCancelButtonPosition">
                        <div>
                          <PrimaryButton
                            className={"simple-button1"}
                            onClick={this.closeTicketDetail}
                            label={"Cancel"}
                          />
                        </div>
                        <div>
                          <PrimaryButton
                            disabled={!this.state.isSaveButtonEnabled}
                            className={"details-tab1"}
                            onClick={this.handleUpdate}
                            label={"Save"}
                          />
                        </div>
                      </div>
                    </Form.Item>
                  )}
                </div>
              </div>
            </div>
          </Form>
        ) : this.state.activetab === 1 ? (
          <Attachment
            TicketID={this.props.TicketInfo.TicketID}
            CreatedBy={this.state.data?.POCEmail}
          />
        ) : this.state.activetab === 2 ? (
          <Attachment
          TicketID={this.props.TicketInfo.TicketID}
          CreatedBy={this.state.data?.POCEmail}
        />
        ) : this.state.activetab === 3 ? (
          <Attachment
          TicketID={this.props.TicketInfo.TicketID}
          CreatedBy={this.state.data?.POCEmail}
        />
        ) : (
          <ActivityLog TicketID={this.props.TicketInfo.TicketID} />
        )}
      </Fragment>
      </div>
    );
  }
}
